// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Sora:wght@300;400;500;600;700&family=DM+Sans:wght@300;400;500&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Google Fonts ─────────────────────────────────────── */

/* ── CSS Variables ────────────────────────────────────── */
:root {
  --blue:         #4f8ef7;
  --violet:       #9b6cf7;
  --pink:         #e06ff5;
  --grad:         linear-gradient(120deg, var(--blue) 0%, var(--violet) 55%, var(--pink) 100%);
  --glass-bg:     rgba(255, 255, 255, 0.65);
  --glass-border: rgba(255, 255, 255, 0.88);
  --shadow:       0 10px 42px rgba(79, 142, 247, 0.18);
  --text-dark:    #1e2a40;
  --text-mid:     #4a5568;
  --text-soft:    #8899b4;
  --input-bg:     rgba(255, 255, 255, 0.72);
  --radius:       18px;
  --radius-sm:    10px;
  --radius-xs:    8px;
}

*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

/* ── Page ────────────────────────────────────────────── */
.register-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 2rem 1.25rem;
  font-family: 'DM Sans', sans-serif;

  background:
    radial-gradient(ellipse 80% 60% at 10% 20%,  rgba(139, 92, 246, 0.22) 0%, transparent 60%),
    radial-gradient(ellipse 70% 50% at 90% 80%,  rgba(59, 130, 246, 0.20) 0%, transparent 60%),
    radial-gradient(ellipse 60% 60% at 50% 50%,  rgba(236, 72, 153, 0.08) 0%, transparent 70%),
    linear-gradient(145deg, #dde8f8 0%, #c9d8f0 40%, #ddd4f5 100%);
  position: relative;
  overflow: hidden;
}

/* Floating blobs */
.register-container::before,
.register-container::after {
  content: '';
  position: fixed;
  border-radius: 50%;
  filter: blur(70px);
  pointer-events: none;
  z-index: 0;
  animation: blob-float 10s ease-in-out infinite alternate;
}
.register-container::before {
  width: 520px; height: 520px;
  background: radial-gradient(circle, rgba(139, 92, 246, 0.24), transparent 70%);
  top: -140px; left: -140px;
}
.register-container::after {
  width: 480px; height: 480px;
  background: radial-gradient(circle, rgba(59, 130, 246, 0.22), transparent 70%);
  bottom: -120px; right: -120px;
  animation-delay: -5s;
}

@keyframes blob-float {
  from { transform: translate(0, 0) scale(1); }
  to   { transform: translate(28px, 18px) scale(1.06); }
}

/* ── Welcome Header ──────────────────────────────────── */
.welcome-header {
  position: relative;
  z-index: 1;
  text-align: center;
  margin-bottom: 1.6rem;
  animation: slideDown 0.65s cubic-bezier(.22,.68,0,1.2) both;
}

@keyframes slideDown {
  from { opacity: 0; transform: translateY(-20px); }
  to   { opacity: 1; transform: translateY(0); }
}

.welcome-header h1 {
  font-family: 'Sora', sans-serif;
  font-size: clamp(1.9rem, 5vw, 2.6rem);
  font-weight: 700;
  letter-spacing: -0.03em;
  background: var(--grad);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  filter: drop-shadow(0 2px 12px rgba(139, 92, 246, 0.22));
}

.welcome-subtitle {
  margin-top: 0.4rem;
  font-size: clamp(0.88rem, 2vw, 1rem);
  color: var(--text-soft);
  max-width: 480px;
  margin-inline: auto;
}

/* ── Card ────────────────────────────────────────────── */
.register-card {
  position: relative;
  z-index: 1;
  background: var(--glass-bg);
  backdrop-filter: blur(20px) saturate(180%);
  -webkit-backdrop-filter: blur(20px) saturate(180%);
  border: 1.5px solid var(--glass-border);
  border-radius: var(--radius);
  box-shadow: var(--shadow), inset 0 1px 0 rgba(255, 255, 255, 0.9);
  padding: 2.2rem 2.4rem;
  width: 100%;
  max-width: 460px;
  animation: riseUp 0.72s cubic-bezier(.22,.68,0,1.2) 0.1s both;
}

/* Gradient shimmer bar at top */
.register-card::before {
  content: '';
  position: absolute;
  top: 0; left: 10%; right: 10%;
  height: 3px;
  border-radius: 0 0 4px 4px;
  background: var(--grad);
  opacity: 0.88;
}

@keyframes riseUp {
  from { opacity: 0; transform: translateY(28px) scale(0.97); }
  to   { opacity: 1; transform: translateY(0) scale(1); }
}

/* ── Card Title ──────────────────────────────────────── */
.register-card > h2,
.register-header {
  font-family: 'Sora', sans-serif;
  text-align: center;
  font-size: clamp(1.1rem, 3vw, 1.38rem);
  font-weight: 600;
  color: var(--text-dark);
  margin-bottom: 1.5rem;
  letter-spacing: -0.02em;
}

/* ── Form ────────────────────────────────────────────── */
.register-form {
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
}

/* Two-column row helper */
.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.75rem;
}

/* ── Input Group ─────────────────────────────────────── */
.input-group {
  display: flex;
  flex-direction: column;
  gap: 0.38rem;
}

.input-group label {
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--text-mid);
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.input-group input,
.register-form select {
  width: 100%;
  min-width: 0;
  padding: 0.68rem 0.95rem;
  background: var(--input-bg);
  border: 1.5px solid rgba(148, 163, 202, 0.35);
  border-radius: var(--radius-xs);
  font-family: 'DM Sans', sans-serif;
  font-size: 0.93rem;
  color: var(--text-dark);
  transition: border-color 0.25s, box-shadow 0.25s, background 0.25s;
  outline: none;
  appearance: none;
  -webkit-appearance: none;
}

.input-group input::placeholder {
  color: var(--text-soft);
  font-weight: 300;
}

.input-group input:focus,
.register-form select:focus {
  background: rgba(255, 255, 255, 0.92);
  border-color: var(--violet);
  box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.14);
}

/* Select wrapper for custom arrow */
.select-wrapper {
  position: relative;
}
.select-wrapper::after {
  content: '▾';
  position: absolute;
  right: 0.85rem;
  top: 50%;
  transform: translateY(-50%);
  color: var(--text-soft);
  font-size: 0.75rem;
  pointer-events: none;
}

.register-form select:disabled {
  background: rgba(241, 245, 249, 0.7);
  color: var(--text-soft);
  cursor: not-allowed;
  opacity: 0.7;
}

/* ── Register Button ─────────────────────────────────── */
.register-button {
  position: relative;
  overflow: hidden;
  background: var(--grad);
  background-size: 200% 100%;
  color: white;
  border: none;
  padding: 0.85rem;
  border-radius: var(--radius-sm);
  font-family: 'Sora', sans-serif;
  font-size: 0.96rem;
  font-weight: 600;
  letter-spacing: 0.03em;
  cursor: pointer;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-position 0.5s, transform 0.2s, box-shadow 0.2s;
  box-shadow: 0 4px 18px rgba(139, 92, 246, 0.34);
  margin-top: 0.35rem;
}

/* Shine sweep on hover */
.register-button::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(105deg, transparent 40%, rgba(255,255,255,0.22) 50%, transparent 60%);
  transform: translateX(-100%);
  transition: transform 0.5s;
}
.register-button:hover::after { transform: translateX(100%); }

.register-button:hover {
  background-position: 100% 0;
  transform: translateY(-2px);
  box-shadow: 0 8px 28px rgba(139, 92, 246, 0.42);
}

.register-button:active { transform: translateY(0); }

.register-button:disabled {
  opacity: 0.65;
  cursor: not-allowed;
  transform: none !important;
  box-shadow: none !important;
}

/* ── Spinner ─────────────────────────────────────────── */
.button-spinner {
  display: inline-block;
  width: 20px; height: 20px;
  border: 2.5px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: white;
  animation: spin 0.65s linear infinite;
}
@keyframes spin { to { transform: rotate(360deg); } }

/* ── Login Link ──────────────────────────────────────── */
.login-options {
  display: flex;
  justify-content: center;
  margin-top: 0.8rem;
}

.login-link {
  font-size: 0.88rem;
  color: var(--text-mid);
}

.login-link a {
  color: var(--violet);
  text-decoration: none;
  font-weight: 600;
  transition: color 0.2s, filter 0.2s;
}
.login-link a:hover {
  color: var(--pink);
  filter: drop-shadow(0 0 6px rgba(224, 111, 245, 0.45));
}

/* ── Messages ────────────────────────────────────────── */
.error-message {
  color: #c53030;
  background: linear-gradient(135deg, rgba(254,215,215,0.82), rgba(254,226,226,0.82));
  backdrop-filter: blur(8px);
  border: 1px solid rgba(252, 165, 165, 0.5);
  padding: 0.68rem 0.95rem;
  border-radius: var(--radius-xs);
  font-size: 0.86rem;
  text-align: center;
  animation: shake 0.35s ease both;
}

.success-message {
  color: #276749;
  background: linear-gradient(135deg, rgba(198,246,213,0.82), rgba(154,230,180,0.55));
  border: 1px solid rgba(104, 211, 145, 0.5);
  padding: 0.68rem 0.95rem;
  border-radius: var(--radius-xs);
  font-size: 0.86rem;
  text-align: center;
  animation: fadeIn 0.4s ease both;
}

@keyframes shake {
  0%,100% { transform: translateX(0); }
  25%      { transform: translateX(-5px); }
  75%      { transform: translateX(5px); }
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(-6px); }
  to   { opacity: 1; transform: translateY(0); }
}

/* ── Responsive ──────────────────────────────────────── */
@media (max-width: 560px) {
  .register-card { padding: 1.9rem 1.5rem; }
  .form-row { grid-template-columns: 1fr; }
}

@media (max-width: 400px) {
  .register-card { padding: 1.5rem 1.1rem; border-radius: 14px; }
  .welcome-header h1 { font-size: 1.75rem; }
  .register-button { height: 45px; font-size: 0.92rem; }
}`, "",{"version":3,"sources":["webpack://./src/components/Register.css"],"names":[],"mappings":"AAAA,4DAA4D;;AAG5D,4DAA4D;AAC5D;EACE,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,4FAA4F;EAC5F,yCAAyC;EACzC,yCAAyC;EACzC,oDAAoD;EACpD,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,yCAAyC;EACzC,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,yBAAyB,sBAAsB,EAAE,SAAS,EAAE,UAAU,EAAE;;AAExE,2DAA2D;AAC3D;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,qBAAqB;EACrB,kCAAkC;;EAElC;;;;kEAIgE;EAChE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;;EAEE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,UAAU;EACV,wDAAwD;AAC1D;AACA;EACE,YAAY,EAAE,aAAa;EAC3B,8EAA8E;EAC9E,WAAW,EAAE,YAAY;AAC3B;AACA;EACE,YAAY,EAAE,aAAa;EAC3B,8EAA8E;EAC9E,cAAc,EAAE,aAAa;EAC7B,oBAAoB;AACtB;;AAEA;EACE,OAAO,mCAAmC,EAAE;EAC5C,OAAO,4CAA4C,EAAE;AACvD;;AAEA,2DAA2D;AAC3D;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,qBAAqB;EACrB,2DAA2D;AAC7D;;AAEA;EACE,OAAO,UAAU,EAAE,4BAA4B,EAAE;EACjD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;EACvB,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;EAClB,wDAAwD;AAC1D;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,2DAA2D;AAC3D;EACE,kBAAkB;EAClB,UAAU;EACV,2BAA2B;EAC3B,0CAA0C;EAC1C,kDAAkD;EAClD,uCAAuC;EACvC,4BAA4B;EAC5B,iEAAiE;EACjE,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,6DAA6D;AAC/D;;AAEA,gCAAgC;AAChC;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM,EAAE,SAAS,EAAE,UAAU;EAC7B,WAAW;EACX,0BAA0B;EAC1B,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,OAAO,UAAU,EAAE,iCAAiC,EAAE;AACxD;;AAEA,2DAA2D;AAC3D;;EAEE,+BAA+B;EAC/B,kBAAkB;EAClB,sCAAsC;EACtC,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;AACd;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,2BAA2B;EAC3B,6CAA6C;EAC7C,+BAA+B;EAC/B,kCAAkC;EAClC,kBAAkB;EAClB,uBAAuB;EACvB,kEAAkE;EAClE,aAAa;EACb,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;;EAEE,qCAAqC;EACrC,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,QAAQ;EACR,2BAA2B;EAC3B,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA,2DAA2D;AAC3D;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,0BAA0B;EAC1B,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qEAAqE;EACrE,+CAA+C;EAC/C,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,iGAAiG;EACjG,4BAA4B;EAC5B,0BAA0B;AAC5B;AACA,gCAAgC,2BAA2B,EAAE;;AAE7D;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA,0BAA0B,wBAAwB,EAAE;;AAEpD;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA,2DAA2D;AAC3D;EACE,qBAAqB;EACrB,WAAW,EAAE,YAAY;EACzB,4CAA4C;EAC5C,kBAAkB;EAClB,uBAAuB;EACvB,qCAAqC;AACvC;AACA,kBAAkB,KAAK,yBAAyB,EAAE,EAAE;;AAEpD,2DAA2D;AAC3D;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;EAChB,mCAAmC;AACrC;AACA;EACE,kBAAkB;EAClB,sDAAsD;AACxD;;AAEA,2DAA2D;AAC3D;EACE,cAAc;EACd,mFAAmF;EACnF,0BAA0B;EAC1B,0CAA0C;EAC1C,wBAAwB;EACxB,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,mFAAmF;EACnF,0CAA0C;EAC1C,wBAAwB;EACxB,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,UAAU,wBAAwB,EAAE;EACpC,WAAW,2BAA2B,EAAE;EACxC,WAAW,0BAA0B,EAAE;AACzC;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA,2DAA2D;AAC3D;EACE,iBAAiB,sBAAsB,EAAE;EACzC,YAAY,0BAA0B,EAAE;AAC1C;;AAEA;EACE,iBAAiB,sBAAsB,EAAE,mBAAmB,EAAE;EAC9D,qBAAqB,kBAAkB,EAAE;EACzC,mBAAmB,YAAY,EAAE,kBAAkB,EAAE;AACvD","sourcesContent":["/* ── Google Fonts ─────────────────────────────────────── */\n@import url('https://fonts.googleapis.com/css2?family=Sora:wght@300;400;500;600;700&family=DM+Sans:wght@300;400;500&display=swap');\n\n/* ── CSS Variables ────────────────────────────────────── */\n:root {\n  --blue:         #4f8ef7;\n  --violet:       #9b6cf7;\n  --pink:         #e06ff5;\n  --grad:         linear-gradient(120deg, var(--blue) 0%, var(--violet) 55%, var(--pink) 100%);\n  --glass-bg:     rgba(255, 255, 255, 0.65);\n  --glass-border: rgba(255, 255, 255, 0.88);\n  --shadow:       0 10px 42px rgba(79, 142, 247, 0.18);\n  --text-dark:    #1e2a40;\n  --text-mid:     #4a5568;\n  --text-soft:    #8899b4;\n  --input-bg:     rgba(255, 255, 255, 0.72);\n  --radius:       18px;\n  --radius-sm:    10px;\n  --radius-xs:    8px;\n}\n\n*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }\n\n/* ── Page ────────────────────────────────────────────── */\n.register-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n  padding: 2rem 1.25rem;\n  font-family: 'DM Sans', sans-serif;\n\n  background:\n    radial-gradient(ellipse 80% 60% at 10% 20%,  rgba(139, 92, 246, 0.22) 0%, transparent 60%),\n    radial-gradient(ellipse 70% 50% at 90% 80%,  rgba(59, 130, 246, 0.20) 0%, transparent 60%),\n    radial-gradient(ellipse 60% 60% at 50% 50%,  rgba(236, 72, 153, 0.08) 0%, transparent 70%),\n    linear-gradient(145deg, #dde8f8 0%, #c9d8f0 40%, #ddd4f5 100%);\n  position: relative;\n  overflow: hidden;\n}\n\n/* Floating blobs */\n.register-container::before,\n.register-container::after {\n  content: '';\n  position: fixed;\n  border-radius: 50%;\n  filter: blur(70px);\n  pointer-events: none;\n  z-index: 0;\n  animation: blob-float 10s ease-in-out infinite alternate;\n}\n.register-container::before {\n  width: 520px; height: 520px;\n  background: radial-gradient(circle, rgba(139, 92, 246, 0.24), transparent 70%);\n  top: -140px; left: -140px;\n}\n.register-container::after {\n  width: 480px; height: 480px;\n  background: radial-gradient(circle, rgba(59, 130, 246, 0.22), transparent 70%);\n  bottom: -120px; right: -120px;\n  animation-delay: -5s;\n}\n\n@keyframes blob-float {\n  from { transform: translate(0, 0) scale(1); }\n  to   { transform: translate(28px, 18px) scale(1.06); }\n}\n\n/* ── Welcome Header ──────────────────────────────────── */\n.welcome-header {\n  position: relative;\n  z-index: 1;\n  text-align: center;\n  margin-bottom: 1.6rem;\n  animation: slideDown 0.65s cubic-bezier(.22,.68,0,1.2) both;\n}\n\n@keyframes slideDown {\n  from { opacity: 0; transform: translateY(-20px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n.welcome-header h1 {\n  font-family: 'Sora', sans-serif;\n  font-size: clamp(1.9rem, 5vw, 2.6rem);\n  font-weight: 700;\n  letter-spacing: -0.03em;\n  background: var(--grad);\n  -webkit-background-clip: text;\n  background-clip: text;\n  color: transparent;\n  filter: drop-shadow(0 2px 12px rgba(139, 92, 246, 0.22));\n}\n\n.welcome-subtitle {\n  margin-top: 0.4rem;\n  font-size: clamp(0.88rem, 2vw, 1rem);\n  color: var(--text-soft);\n  max-width: 480px;\n  margin-inline: auto;\n}\n\n/* ── Card ────────────────────────────────────────────── */\n.register-card {\n  position: relative;\n  z-index: 1;\n  background: var(--glass-bg);\n  backdrop-filter: blur(20px) saturate(180%);\n  -webkit-backdrop-filter: blur(20px) saturate(180%);\n  border: 1.5px solid var(--glass-border);\n  border-radius: var(--radius);\n  box-shadow: var(--shadow), inset 0 1px 0 rgba(255, 255, 255, 0.9);\n  padding: 2.2rem 2.4rem;\n  width: 100%;\n  max-width: 460px;\n  animation: riseUp 0.72s cubic-bezier(.22,.68,0,1.2) 0.1s both;\n}\n\n/* Gradient shimmer bar at top */\n.register-card::before {\n  content: '';\n  position: absolute;\n  top: 0; left: 10%; right: 10%;\n  height: 3px;\n  border-radius: 0 0 4px 4px;\n  background: var(--grad);\n  opacity: 0.88;\n}\n\n@keyframes riseUp {\n  from { opacity: 0; transform: translateY(28px) scale(0.97); }\n  to   { opacity: 1; transform: translateY(0) scale(1); }\n}\n\n/* ── Card Title ──────────────────────────────────────── */\n.register-card > h2,\n.register-header {\n  font-family: 'Sora', sans-serif;\n  text-align: center;\n  font-size: clamp(1.1rem, 3vw, 1.38rem);\n  font-weight: 600;\n  color: var(--text-dark);\n  margin-bottom: 1.5rem;\n  letter-spacing: -0.02em;\n}\n\n/* ── Form ────────────────────────────────────────────── */\n.register-form {\n  display: flex;\n  flex-direction: column;\n  gap: 0.9rem;\n}\n\n/* Two-column row helper */\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0.75rem;\n}\n\n/* ── Input Group ─────────────────────────────────────── */\n.input-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.38rem;\n}\n\n.input-group label {\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--text-mid);\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n}\n\n.input-group input,\n.register-form select {\n  width: 100%;\n  min-width: 0;\n  padding: 0.68rem 0.95rem;\n  background: var(--input-bg);\n  border: 1.5px solid rgba(148, 163, 202, 0.35);\n  border-radius: var(--radius-xs);\n  font-family: 'DM Sans', sans-serif;\n  font-size: 0.93rem;\n  color: var(--text-dark);\n  transition: border-color 0.25s, box-shadow 0.25s, background 0.25s;\n  outline: none;\n  appearance: none;\n  -webkit-appearance: none;\n}\n\n.input-group input::placeholder {\n  color: var(--text-soft);\n  font-weight: 300;\n}\n\n.input-group input:focus,\n.register-form select:focus {\n  background: rgba(255, 255, 255, 0.92);\n  border-color: var(--violet);\n  box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.14);\n}\n\n/* Select wrapper for custom arrow */\n.select-wrapper {\n  position: relative;\n}\n.select-wrapper::after {\n  content: '▾';\n  position: absolute;\n  right: 0.85rem;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--text-soft);\n  font-size: 0.75rem;\n  pointer-events: none;\n}\n\n.register-form select:disabled {\n  background: rgba(241, 245, 249, 0.7);\n  color: var(--text-soft);\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n/* ── Register Button ─────────────────────────────────── */\n.register-button {\n  position: relative;\n  overflow: hidden;\n  background: var(--grad);\n  background-size: 200% 100%;\n  color: white;\n  border: none;\n  padding: 0.85rem;\n  border-radius: var(--radius-sm);\n  font-family: 'Sora', sans-serif;\n  font-size: 0.96rem;\n  font-weight: 600;\n  letter-spacing: 0.03em;\n  cursor: pointer;\n  height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-position 0.5s, transform 0.2s, box-shadow 0.2s;\n  box-shadow: 0 4px 18px rgba(139, 92, 246, 0.34);\n  margin-top: 0.35rem;\n}\n\n/* Shine sweep on hover */\n.register-button::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(105deg, transparent 40%, rgba(255,255,255,0.22) 50%, transparent 60%);\n  transform: translateX(-100%);\n  transition: transform 0.5s;\n}\n.register-button:hover::after { transform: translateX(100%); }\n\n.register-button:hover {\n  background-position: 100% 0;\n  transform: translateY(-2px);\n  box-shadow: 0 8px 28px rgba(139, 92, 246, 0.42);\n}\n\n.register-button:active { transform: translateY(0); }\n\n.register-button:disabled {\n  opacity: 0.65;\n  cursor: not-allowed;\n  transform: none !important;\n  box-shadow: none !important;\n}\n\n/* ── Spinner ─────────────────────────────────────────── */\n.button-spinner {\n  display: inline-block;\n  width: 20px; height: 20px;\n  border: 2.5px solid rgba(255, 255, 255, 0.3);\n  border-radius: 50%;\n  border-top-color: white;\n  animation: spin 0.65s linear infinite;\n}\n@keyframes spin { to { transform: rotate(360deg); } }\n\n/* ── Login Link ──────────────────────────────────────── */\n.login-options {\n  display: flex;\n  justify-content: center;\n  margin-top: 0.8rem;\n}\n\n.login-link {\n  font-size: 0.88rem;\n  color: var(--text-mid);\n}\n\n.login-link a {\n  color: var(--violet);\n  text-decoration: none;\n  font-weight: 600;\n  transition: color 0.2s, filter 0.2s;\n}\n.login-link a:hover {\n  color: var(--pink);\n  filter: drop-shadow(0 0 6px rgba(224, 111, 245, 0.45));\n}\n\n/* ── Messages ────────────────────────────────────────── */\n.error-message {\n  color: #c53030;\n  background: linear-gradient(135deg, rgba(254,215,215,0.82), rgba(254,226,226,0.82));\n  backdrop-filter: blur(8px);\n  border: 1px solid rgba(252, 165, 165, 0.5);\n  padding: 0.68rem 0.95rem;\n  border-radius: var(--radius-xs);\n  font-size: 0.86rem;\n  text-align: center;\n  animation: shake 0.35s ease both;\n}\n\n.success-message {\n  color: #276749;\n  background: linear-gradient(135deg, rgba(198,246,213,0.82), rgba(154,230,180,0.55));\n  border: 1px solid rgba(104, 211, 145, 0.5);\n  padding: 0.68rem 0.95rem;\n  border-radius: var(--radius-xs);\n  font-size: 0.86rem;\n  text-align: center;\n  animation: fadeIn 0.4s ease both;\n}\n\n@keyframes shake {\n  0%,100% { transform: translateX(0); }\n  25%      { transform: translateX(-5px); }\n  75%      { transform: translateX(5px); }\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; transform: translateY(-6px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n/* ── Responsive ──────────────────────────────────────── */\n@media (max-width: 560px) {\n  .register-card { padding: 1.9rem 1.5rem; }\n  .form-row { grid-template-columns: 1fr; }\n}\n\n@media (max-width: 400px) {\n  .register-card { padding: 1.5rem 1.1rem; border-radius: 14px; }\n  .welcome-header h1 { font-size: 1.75rem; }\n  .register-button { height: 45px; font-size: 0.92rem; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
